import { Warning } from "@phosphor-icons/react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Th, Td } from "@/components/common";
import { qty } from "@/lib/api";

export default function StockShortageDialog({ items, onCancel, onConfirm }) {
  return (
    <AlertDialog open={items.length > 0} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="max-w-xl rounded-[4px]" data-testid="stock-shortage-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 font-display text-xl text-red-600">
            <Warning size={22} weight="fill" /> Stok Yetersiz
          </AlertDialogTitle>
          <AlertDialogDescription>
            Aşağıdaki ürünlerde satılan miktar mevcut stoktan fazla. Kaydederseniz stok eksiye düşecek.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <table className="w-full" data-testid="stock-shortage-table">
          <thead><tr><Th>Ürün</Th><Th right>Mevcut</Th><Th right>Satılan</Th><Th right>Eksik</Th></tr></thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id} data-testid={`stock-shortage-row-${s.code}`}>
                <Td>{s.name}</Td>
                <Td right>{qty(s.stock)} {s.unit}</Td>
                <Td right>{qty(s.need)}</Td>
                <Td right className="font-semibold text-red-600">{qty(s.need - s.stock)}</Td>
              </tr>
            ))}
          </tbody>
        </table>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="stock-shortage-cancel-button">Vazgeç, düzelteyim</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700" data-testid="stock-shortage-confirm-button">
            Yine de kaydet
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
